import { apiFetch } from '$lib/api/helpers';
import type {
	ProductResponse,
	ProductSearchResponse,
	ProductTypeResponse,
	CategoryResponse
} from '$lib/types/product';

// The catalogue is mirrored read-only from ProQuote (the master catalog) and written
// only by the periodic sync — there are no update/delete endpoints here. The one
// exception is "add a genuinely-missing product": createProduct() proxies to ProQuote,
// which creates it (designer_created, pending review) and mirrors it straight back.
// Manage/price everything else in ProQuote.

const PATH = '/products/';

export async function fetchProducts() {
	return apiFetch<Array<ProductResponse>>(PATH);
}

export async function fuzzySearchProducts(query: string) {
	return apiFetch<ProductSearchResponse>(`${PATH}fuzzy_search/?q=${query}`);
}

export async function createProduct(product: {
	product_type: number;
	name: string;
	description?: string;
}) {
	return apiFetch<ProductResponse>(PATH, {
		method: 'POST',
		body: JSON.stringify(product)
	});
}

export async function fetchProductById(id: number) {
	return apiFetch<ProductResponse>(`${PATH}${id}/`);
}

export async function fetchProductTypes() {
	return apiFetch<Array<ProductTypeResponse>>('/product_types/');
}

export async function fetchProductTypeById(id: number) {
	return apiFetch<ProductTypeResponse>(`/product_types/${id}/`);
}

export async function fetchCategories() {
	return apiFetch<Array<CategoryResponse>>('/product_categories/');
}
